export default "__VITE_ASSET__8d606e45__"